import {combineReducers} from 'redux';
import {getLawDocsDetailReducer } from './getLawDocsDetail';
const reducer = combineReducers({
   getLawDocsDetailReducer
    });
    
    export default reducer;
